export const DEFAULT_EXPIRY_THRESHOLD_DAYS = 3;
export const DEFAULT_DASHBOARD_EXPIRY_DAYS = 7;

export type ExpiryStatus = 'expired' | 'expiring-today' | 'expiring-soon' | 'fresh' | 'none';

export function resolveExpiryThreshold(
  item: { expiryThresholdDays: number | null } | null,
  storageLocation: { expiryThresholdDays: number | null } | null,
  household: { expiryThresholdDays: number } | null
): number {
  return (
    item?.expiryThresholdDays ??
    storageLocation?.expiryThresholdDays ??
    household?.expiryThresholdDays ??
    DEFAULT_EXPIRY_THRESHOLD_DAYS
  );
}

export function resolveDashboardExpiryDays(
  household: { dashboardExpiryDays: number } | null
): number {
  return household?.dashboardExpiryDays ?? DEFAULT_DASHBOARD_EXPIRY_DAYS;
}

export function getExpiryStatus(
  daysUntilExpiry: number | null,
  thresholdDays: number
): ExpiryStatus {
  if (daysUntilExpiry === null) return 'none';
  if (daysUntilExpiry < 0) return 'expired';
  if (daysUntilExpiry <= 1) return 'expiring-today';
  if (daysUntilExpiry <= thresholdDays) return 'expiring-soon';
  return 'fresh';
}
